
import { CLEAR_ROOM, CONFERENCE_LEFT, getCurrentConference } from '../base/conference';
import { getLocalParticipant, getLocalParticipantId } from '../base/participants';
import { ReducerRegistry, StateListenerRegistry } from '../base/redux';
import { getCurrentMode, setVideoLayoutMode, videoLayoutMode } from '../video-layout-mode';
import { SET_SCREEN_AUDIO_SHARE_STATE, SET_SCREEN_VIDEO_SHARE_STATE } from './actionTypes';

const DEFAULT_STATE = {
    isSharingAudio: false,
    sharingVideo: { member_uuid: null, track_id: null },
    screenModal: true
};

ReducerRegistry.register('features/screen-share', (state = DEFAULT_STATE, action) => {
    const { sharingAudio, sharingVideo } = action;

    switch (action.type) {
        case SET_SCREEN_AUDIO_SHARE_STATE:
            return {
                ...state,
                sharingAudio
            };
        
        case SET_SCREEN_VIDEO_SHARE_STATE:
            let sharing = action.sharingVideo;
            if (!sharing) sharing = DEFAULT_STATE.sharingVideo; 

            return {
                ...state,
                sharingVideo: sharing
            }

        case CLEAR_ROOM:
        case CONFERENCE_LEFT: {
            return {
                ...DEFAULT_STATE
            }
        }
    }
    return state;
});

StateListenerRegistry.register(state => state['features/screen-share'].sharingVideo,
    (sharingVideo, { dispatch, getState }, prevSharingVideo) => {
        const state = getState();
        const conferenceJoined = getCurrentConference(state);
        if (!conferenceJoined) return;

        const local_uuid = getLocalParticipant(state).member_uuid;
        const mode = getCurrentMode(state);
       
        const { member_uuid, track_id } = sharingVideo;
        
        if (prevSharingVideo.member_uuid === local_uuid && !member_uuid) {
            const { prevLayoutMode } = state['features/video-layout-mode'];
            dispatch(setVideoLayoutMode(prevLayoutMode, false));
        } 
        
        if (member_uuid === local_uuid) {
            if (APP.mateManagement.getScreenSharing()) {
                APP.UI.closeModal();
                dispatch(setVideoLayoutMode(videoLayoutMode.screen, false));
            }
        }
    }
);

StateListenerRegistry.register(state => getCurrentConference(state),
    (conferenceJoined, { dispatch, getState }) => {
        const state = getState();
        if (!conferenceJoined) {
            const streaming = getLocalParticipantId(state);
            const id = state['features/screen-share'].sharingVideo.user_id;
            
            if (streaming === id) {
                if (APP.mateManagement.getScreenSharing()) {
                    APP.mateManagement.toggleScreenShare(false);
                }
            }
        }
    }
); 